import { Flex, Image } from '@chakra-ui/react';

interface LogoProps {
  logo: Blob;
}

export const Logo = ({ logo }: LogoProps) => {
  return (
    <Flex maxH={'72px'} maxW='100px' display={'flex'} alignItems='center'>
      <Image src={URL.createObjectURL(logo)} maxH='72px' maxW='100%' borderRadius={'6px'} role='presentation' />
    </Flex>
  );
};
